import { render, staticRenderFns } from "./EditBoardView.vue?vue&type=template&id=765ba5e4&scoped=true"
import script from "./EditBoardView.vue?vue&type=script&lang=js"
export * from "./EditBoardView.vue?vue&type=script&lang=js"
import style0 from "./EditBoardView.vue?vue&type=style&index=0&id=765ba5e4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "765ba5e4",
  null
  
)

export default component.exports